import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { trustBudTokens } from "../../theme/tokens";

export default function PendingActionNotice({
  title,
  body = "",
  steps = [],
  compact = false,
  sx = {},
}) {
  return (
    <Box
      sx={{
        borderRadius: compact ? "16px" : "20px",
        border: "1px solid rgba(215, 226, 238, 0.94)",
        backgroundColor: "#f8fbff",
        px: compact ? 1.5 : 2,
        py: compact ? 1.25 : 1.7,
        display: "grid",
        gap: 1.2,
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: "13px",
            display: "grid",
            placeItems: "center",
            backgroundColor: "#eef5ff",
            color: trustBudTokens.colors.brand.navy700,
            flexShrink: 0,
          }}
        >
          <CircularProgress size={17} sx={{ color: "inherit" }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: "0.98rem", fontWeight: 850, color: "#13233d" }}>
            {title}
          </Typography>
          {body ? (
            <Typography sx={{ mt: 0.25, fontSize: "0.88rem", color: "#60738c", lineHeight: 1.45 }}>
              {body}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {steps.length && !compact ? (
        <Box sx={{ display: "grid", gap: 0.65, pl: 0.25 }}>
          {steps.slice(0, 3).map((step, index) => (
            <Box key={step} sx={{ display: "flex", alignItems: "center", gap: 0.85 }}>
              <Box
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: 999,
                  backgroundColor: index === steps.length - 1 ? trustBudTokens.colors.brand.navy700 : "#cbd8e6",
                }}
              />
              <Typography sx={{ fontSize: "0.78rem", color: "#60738c", fontWeight: 750 }}>
                {step}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : null}
    </Box>
  );
}
